<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Cek Gaji Per Pegawai
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Cek Gaji Per Pegawai</h5>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxPopup
          :visible="loadingVisible"
          :title="loadingTitle"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </DxPopup>

        <div class="dx-form-horizontal">
          <DxForm :col-count="3" label-location="top">
            <DxSimpleItem>
              <DxDateBox
                :show-clear-button="true"
                :use-mask-behavior="true"
                :input-attr="{ 'aria-label': 'Date' }"
                type="date"
                displayFormat="monthAndYear"
                :calendar-options="calendarMonthYear"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="formDataPeriodeGaji"
                @value-changed="onPeriodeGajiChanged"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </DxSimpleItem>

            <!-- Multi-Select Box (TagBox) -->
            <DxSimpleItem>
              <DxTagBox
                v-model="formDataPegawaiIds"
                :data-source="pegawaiSource"
                :show-clear-button="true"
                placeholder="Pilih pegawai"
                width="100%"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                value-expr="id"
                :display-expr="
                  (item) => {
                    if (!item) return '';
                    if (item.nik) return `${item.nik} - ${item.nama}`;
                    return `- ${item.nama}`;
                  }
                "
                :search-enabled="true"
                :search-expr="['nama', 'nik']"
                search-mode="contains"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxTagBox>
            </DxSimpleItem>

            <DxSimpleItem>
              <DxButton
                text="Cek Gaji"
                type="default"
                @click="cekGaji"
                width="100%"
              />
            </DxSimpleItem>
          </DxForm>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <template v-if="gajis">
          <div v-for="(gaji, indexGaji) in gajis" :key="indexGaji">
            <h3>
              <strong>
                {{ formDataPegawaiDatas[indexGaji]["nik"] }} -
                {{ formDataPegawaiDatas[indexGaji]["nama"] }}
              </strong>
              <span
                class="dx-icon dx-icon-user"
                style="
                  color: #1976d2;
                  margin-left: 8px;
                  cursor: pointer;
                  font-size: 16px;
                "
                title="Lihat Data Pegawai"
                @click="
                  onPegawaiIconClick(
                    'pegawai',
                    formDataPegawaiDatas[indexGaji]['id']
                  )
                "
              ></span>
              <span
                class="dx-icon dx-icon-event"
                style="
                  color: #1976d2;
                  margin-left: 8px;
                  cursor: pointer;
                  font-size: 16px;
                "
                title="Lihat Riwayat Absen"
                @click="
                  onPegawaiIconClick(
                    'absen',
                    formDataPegawaiDatas[indexGaji]['id']
                  )
                "
              ></span>
              <span
                class="dx-icon dx-icon-money"
                style="
                  color: #1976d2;
                  margin-left: 8px;
                  cursor: pointer;
                  font-size: 16px;
                "
                title="Lihat Riwayat Gaji"
                @click="
                  onPegawaiIconClick(
                    'gaji',
                    formDataPegawaiDatas[indexGaji]['id']
                  )
                "
              ></span>
            </h3>
            <p
              v-html="
                `${
                  formDataPegawaiDatas[indexGaji]?.riwayat_pekerjaans?.[0]
                    ?.jabatan_print || ''
                }`
              "
            ></p>
            <p>
              Masa Kerja berdasarkan DUK:
              {{ formDataPegawaiDatas[indexGaji]["masa_kerja_tahun"] }} tahun
              {{ formDataPegawaiDatas[indexGaji]["masa_kerja_bulan"] }} bulan
            </p>

            <p>
              <strong>KP Terakhir berdasarkan periode cek gaji:</strong>
              ({{
                commonFunction.formatDateIndonesia(
                  formDataPegawaiDatas[indexGaji]?.simpeg_naik_pangkats?.[0]
                    ?.tgl
                ) || ""
              }}) Gol.
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_naik_pangkats?.[0]
                  ?.golongan.nama || ""
              }}
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_naik_pangkats?.[0]
                  ?.masa_kerja || ""
              }}
              tahun
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_naik_pangkats?.[0]
                  ?.masa_kerja_bulan ?? ""
              }}
              bulan
              <strong>Prediksi selanjutnya:</strong>
              ({{
                commonFunction.formatDateIndonesia(
                  formDataPegawaiDatas[indexGaji]
                    ?.simpeg_naik_pangkat_prediksis?.[0]?.tgl
                ) || ""
              }})
              {{
                formDataPegawaiDatas[indexGaji]
                  ?.simpeg_naik_pangkat_prediksis?.[0]?.golongan.nama || ""
              }}
              {{
                formDataPegawaiDatas[indexGaji]
                  ?.simpeg_naik_pangkat_prediksis?.[0]?.masa_kerja || ""
              }}
              tahun
              {{
                formDataPegawaiDatas[indexGaji]
                  ?.simpeg_naik_pangkat_prediksis?.[0]?.masa_kerja_bulan ?? ""
              }}
              bulan
            </p>

            <p>
              <strong>KGB Terakhir berdasarkan periode cek gaji:</strong>
              ({{
                commonFunction.formatDateIndonesia(
                  formDataPegawaiDatas[indexGaji]?.simpeg_kgbs?.[0]?.tgl
                ) || ""
              }})
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_kgbs?.[0]?.masa_kerja ??
                ""
              }}
              tahun
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_kgbs?.[0]
                  ?.masa_kerja_bulan ?? ""
              }}
              bulan
              <strong>Prediksi selanjutnya:</strong>
              ({{
                commonFunction.formatDateIndonesia(
                  formDataPegawaiDatas[indexGaji]?.simpeg_kgb_prediksis?.[0]
                    ?.tgl
                ) || ""
              }})
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_kgb_prediksis?.[0]
                  ?.masa_kerja || ""
              }}
              tahun
              {{
                formDataPegawaiDatas[indexGaji]?.simpeg_kgb_prediksis?.[0]
                  ?.masa_kerja_bulan ?? ""
              }}

              bulan
            </p>

            <DxScrollView
              direction="horizontal"
              style="
                border: 1px solid #ccc;
                padding: 16px;
                width: 100%;
                height: 150px;
                white-space: nowrap;
              "
              show-scrollbar="always"
            >
              <div style="display: inline-block; min-width: 1000px">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        v-for="item in getTableGaji(
                          formDataPegawaiDatas[indexGaji]?.pegawai_status_id
                        )"
                        :key="item.val"
                      >
                        {{ item.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        v-for="item in getTableGaji(
                          formDataPegawaiDatas[indexGaji]?.pegawai_status_id
                        )"
                        :key="item.val"
                      >
                        {{
                          commonFunction.formatNumberToCurrency(
                            gaji["gajis"][item.val]
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </DxScrollView>
            <br />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import notify from "devextreme/ui/notify";
import DxScrollView from "devextreme-vue/scroll-view";
import { DateTime } from "luxon";
import { useDukListStore } from "@/stores/views/duk-list-store";
import { DxForm, DxSimpleItem } from "devextreme-vue/form";
import DxDateBox from "devextreme-vue/date-box";
import DxTagBox from "devextreme-vue/tag-box";
import DxButton from "devextreme-vue/button";
import * as commonFunction from "@/utils/common-function.js";
import { useCommonStore } from "@/stores/utility/common-store2";
import DxPopup from "devextreme-vue/popup";
// import auth from "../auth";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";

export default {
  components: {
    DxRequiredRule,
    DxValidator,
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxDateBox,
    DxTagBox,
    DxButton,
    DxScrollView,
  },
  setup() {
    const commonStore = useCommonStore();
    const dukListStore = useDukListStore();
    return {
      dukListStore,
      commonFunction,
      commonStore,
    };
  },

  data() {
    return {
      formDataPegawaiDatas: null,
      gajis: null,
      loadingVisible: false,
      loadingTitle: "Loading data pegawai dan jabatan",
      pegawaiSource: null,
      stylingMode: "outlined",
      labelMode: "floating",
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },

      formData: {
        periodeGaji: null,
        pegawaiIds: [],
      },
      formDataPeriodeGaji: null,
      formDataPegawaiIds: null,
      multiSelectOptions: [
        { id: 1, name: "Option 1" },
        { id: 2, name: "Option 2" },
        { id: 3, name: "Option 3" },
        { id: 4, name: "Option 4" },
        { id: 5, name: "Option 5" },
      ],

      tableGajiTetap: [
        { val: "gaji_pokok", name: "Gaji Pokok" },
        { val: "tun_perusahaan", name: "Tun. Perusahaan" },
        { val: "tun_jabatan", name: "Tun. Jabatan" },
        { val: "tun_kemahalan", name: "Tun. Kemahalan" },
        { val: "tun_air", name: "Tun. Air" },
        { val: "tun_transport", name: "Tun. Transport" },
        { val: "tun_pangan", name: "Tun. Pangan" },
        { val: "tun_kesehatan", name: "Tun. Kesehatan" },
        { val: "premi_jkk", name: "Premi JKK" },
        { val: "premi_jkm", name: "Premi JKM" },
        { val: "jml_tdk_hadir", name: "Jml Tdk Hadir" },
        { val: "pot_5_persen", name: "Pot. Ketidakhadiran" },
        { val: "jml_bruto", name: "Jml Bruto" },
        { val: "tun_pph", name: "Tun. PPH" },
        // { val: 'pot_5_persen + item.jml_bruto', name: '' },
        { val: "pot_kesehatan", name: "Pot. Kesehatan" },
        { val: "pot_bpjs_tk_tiga_program", name: "Pot. BPJS TK 3 Program" },
        { val: "pot_bpjs_tk_empat_program", name: "Pot. BPJS TK 4 Program" },
        { val: "pot_pensiun", name: "Pot. Pensiun IFG LIFE" },
        { val: "ifg_mandiri", name: "Pot. IFG MANDIRI" },
        { val: "pot_pph", name: "Pot. PPH Pasal 21" },
        { val: "total_diterima", name: "Jml Diterima" },
      ],

      tableGajiHonor: [
        { val: "masa_kerja", name: "Masa Kerja (Thn)" },
        { val: "honor_umk_jml", name: "Honor (UMK)" },
        { val: "kenaikan_masa_kerja", name: "Tamb. Upah Masa Kerja" },
        { val: "tun_kesehatan", name: "Tun. Kesehatan" },
        { val: "premi_jkk", name: "Premi JKK" },
        { val: "premi_jkm", name: "Premi JKM" },
        { val: "jml_tdk_hadir", name: "Jml Tdk Hadir" },
        { val: "pot_5_persen", name: "Pot. Ketidakhadiran" },
        { val: "jml_bruto", name: "Jumlah Bruto" },
        { val: "pot_kesehatan", name: "Pot. Kesehatan" },
        { val: "pot_bpjs_tk_dua_persen", name: "Pot. BPJS TK 2%" },
        { val: "ifg_mandiri", name: "Pot. IFG Mandiri" },
        { val: "total_diterima", name: "Jml Diterima" },
      ],
      tableGajiKontrak: [
        { val: "masa_kerja", name: "Masa Kerja (Thn)" },
        { val: "honor_umk_jml", name: "Honor (UMK)" },
        { val: "kenaikan_masa_kerja", name: "Tamb. Upah Masa Kerja" },
        { val: "tun_kesehatan", name: "Tun. Kesehatan" },
        { val: "premi_jkk", name: "Premi JKK" },
        { val: "premi_jkm", name: "Premi JKM" },
        { val: "jml_tdk_hadir", name: "Jml Tdk Hadir" },
        { val: "pot_5_persen", name: "Pot. Ketidakhadiran" },
        {
          val: "tun_bpjs_tk_satu_sembilanbelas_persen",
          name: "Tunj. BPJS TK 1.19%",
        },
        { val: "jml_bruto", name: "Jumlah Bruto" },
        { val: "pot_kesehatan", name: "Pot. Kesehatan" },
        {
          val: "pot_bpjs_tk_satu_sembilanbelas_persen",
          name: "Pot. BPJS TK 1.19%",
        },
        { val: "ifg_mandiri", name: "Pot. IFG Mandiri" },
        { val: "total_diterima", name: "Jml Diterima" },
      ],
    };
  },
  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {},
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    onPegawaiIconClick(page, pegawaiId) {
      if (page === "absen") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (page === "gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (page === "pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
    getTableGaji(statusId) {
      if (statusId < 4) {
        return this.tableGajiTetap;
      } else if (statusId === 4) {
        return this.tableGajiHonor;
      } else {
        return this.tableGajiKontrak;
      }
    },

    async cekGaji(e) {
      this.gajis = null; // Reset gajis when reloading
      const result = e.validationGroup.validate();
      if (!result) {
        notify("Form tidak valid, silakan periksa kembali", "error");
        return;
      }

      const periodeGaji = DateTime.fromJSDate(
        new Date(this.formDataPeriodeGaji)
      ).toFormat("yyyy-MM-dd");

      const pegawaiIds = this.formDataPegawaiIds;

      this.formDataPegawaiDatas = this.pegawaiSource.filter((pegawai) =>
        pegawaiIds.includes(pegawai.id)
      );

      const pegawaiData = this.formDataPegawaiDatas.map((pegawai) => ({
        id: pegawai.id,
        pegawai_status_id: pegawai.pegawai_status_id,
        jabatan_id: pegawai.jabatan_id,
      }));

      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        this.loadingVisible = true;
        this.loadingTitle = "Memeriksa gaji...";

        const response = await axios.post(
          `${API_BASE_URL}/gaji/cek-gaji`,
          {
            periode_gaji: periodeGaji,
            pegawais: pegawaiData,
          },
          config
        );
        this.loadingVisible = false;
        if (response.data.status) {
          this.showGaji(response.data.data);
        }
      } catch (error) {
        notify("Error saat memeriksa gaji: " + error.message, "error");
        return false; // If there was an error
      }
    },

    showGaji(gajiData) {
      this.gajis = gajiData;
    },

    onPeriodeGajiChanged(e) {
      this.formDataPegawaiIds = null; // Reset pegawaiIds when reloading

      this.reloadPegawai(
        DateTime.fromJSDate(new Date(e.value)).toFormat("yyyy-MM-dd")
      );
    },
    async reloadPegawai(periodeGaji) {
      this.loadingVisible = true;
      this.loadingTitle = "Loading data pegawai dan jabatan...";

      this.gajis = null;

      try {
        const dataDuk = await this.dukListStore.getData([
          ["tgl", "=", periodeGaji], //akan langsung di ubah ke enf of month in laravel
          ["capeg_tetap", "=", false], //artinya termasuk honor
          ["include_direksi", "=", true],
          ["definitif", "=", true], //gaji mengikuti defintif, tidak rPekerjeaan yang terbaru. jadi misal, terbaru adalah PLT, gaji ikut ke definitif
        ]);
        this.pegawaiSource = dataDuk.data;
        this.loadingVisible = false;
      } catch (error) {
        console.error("Error fetching dataDuk:", error);
        this.loadingVisible = false;
        notify("Error fetching data pegawai " + error, "error");
      }
    },
  },
};
</script>
